define([
    "./commonsUserService",
    "./commonsUserModule"
], function(){

});